var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('permission-list-search-component',{staticClass:"mb-4"}),_c('permission-list-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }